module.exports = __webpack_public_path__ + "static/logos/surf-forecast__logo-bd64d8b9dcbc3efbbfce319948ed28e9.png";